import * as types from '../constants/quote/step02'

export default function quoteReducer(
    state: any = {
        findAddress: {
            loading: false,
            done: false,
            error: null,
            response: [],
        },
        getAddress: {
            loading: false,
            done: false,
            error: null,
            response: [],
        },
        getLatLong: {
            loading: false,
            done: false,
            error: null,
            response: [],
        },
        museums: {
            loading: false,
            errors: null,
            data: [],
        },
        storageLocations: {
            loading: false,
            errors: null,
            data: [],
        },
    },
    action: any) {

    switch (action.type) {

        /**
         *     Try to find address list from Postcode
         */
        case 'FIND_ADDRESS_PENDING': {
            return { ...state, findAddress: { loading: true } }
        }

        case 'FIND_ADDRESS_REJECTED': {
            return { ...state, findAddress: { loading: false, error: action.payload } }
        }

        case 'FIND_ADDRESS_FULFILLED': {
            return {
                ...state,
                findAddress: {
                    loading: false, done: true, error: null, response: action.payload.Items,
                },
            }
        }

        /**
         *     Try to find latitude and longitude from Postcode
         */
        case 'FIND_LAT_LONG_PENDING': {
            return { ...state, getLatLong: { ...state.getLatLong, loading: true } }
        }

        case 'FIND_LAT_LONG_REJECTED': {
            return { ...state, getLatLong: { ...state.getLatLong, loading: false, error: action.payload } }
        }

        case 'FIND_LAT_LONG_FULFILLED': {
            return {
                ...state,
                getLatLong: {
                    ...state.getLatLong, loading: false, done: true, error: null, response: action.payload.result,
                },
            }
        }

        /**
         *     Try to find address list from Postcode
         */
        case 'GET_ADDRESS_PENDING': {
            return { ...state, getAddress: { loading: true } }
        }

        case 'GET_ADDRESS_REJECTED': {
            return { ...state, getAddress: { loading: false, error: action.payload } }
        }

        case 'GET_ADDRESS_FULFILLED': {
            return {
                ...state,
                getAddress: {
                    loading: false, done: true, error: null, response: action.payload.Items[0],
                },
            }
        }

        case types.FETCH_MUSEUMS_REQUEST: {
            return {
                ...state,
                museums: {
                    ...state.museums,
                    loading: true,
                },
            }
        }
        case types.FETCH_MUSEUMS_SUCCESS: {
            return {
                ...state,
                museums: {
                    ...state.museums,
                    data: action.payload,
                },
            }
        }
        case types.FETCH_MUSEUMS_FAILURE: {
            return {
                ...state,
                museums: {
                    ...state.museums,
                    errors: action.payload,
                },
            }
        }
        case types.FETCH_MUSEUMS_FULFILL: {
            return {
                ...state,
                museums: {
                    ...state.museums,
                    loading: false,
                },
            }
        }
        case types.FETCH_STORAGE_LOCATIONS_REQUEST: {
            return {
                ...state,
                storageLocations: {
                    ...state.storageLocations,
                    loading: true,
                },
            }
        }
        case types.FETCH_STORAGE_LOCATIONS_SUCCESS: {
            return {
                ...state,
                storageLocations: {
                    ...state.storageLocations,
                    data: action.payload,
                },
            }
        }
        case types.FETCH_STORAGE_LOCATIONS_FAILURE: {
            return {
                ...state,
                storageLocations: {
                    ...state.storageLocations,
                    errors: action.payload,
                },
            }
        }
        case types.FETCH_STORAGE_LOCATIONS_FULFILL: {
            return {
                ...state,
                storageLocations: {
                    ...state.storageLocations,
                    loading: false,
                },
            }
        }

        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/address.ts